export default "__VITE_ASSET__100a75d6__"